import {
  Button,
  Icon,
  Spacer,
  SvgChrome,
  SvgMobileDevices,
  Text,
  TextButton,
} from '@loomhq/lens';
import React, { useEffect } from 'react';

import { DOWNLOAD_RECORDER } from 'constants/checklist';
import {
  GET_STARTED_CHECKLIST_DESKTOP_APP_INSTALL_CLICKED,
  GET_STARTED_CHECKLIST_EXTENSION_INSTALL_CLICKED,
  GET_STARTED_CHECKLIST_MOBILE_APP_INSTALL_CLICKED,
  GET_STARTED_CHECKLIST_SHOULD_SHOW_MOBILE_NUDGE_EXPERIMENT,
} from 'constants/events';
import { EXP_MOBILE_NUDGE_IN_ONBOARDING_CHECKLIST } from 'constants/featureFlag';
import { CHROME_EXT_WEBSTORE_URL, MOBILE_WEB } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import {
  getSupportedPlatformType,
  isSupportedDesktopPlatform,
} from 'utilities/download-desktop';

import { useCompleteChecklistItem } from 'hooks/checklist';

import DownloadDesktopButton from '../../../../download-desktop-button';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const DownloadCTA = ({ isComplete }) => {
  const { completeChecklistItem } = useCompleteChecklistItem(DOWNLOAD_RECORDER);

  const platform = getSupportedPlatformType();

  const shouldShowMobileNudgeExperiment = !isComplete;

  useEffect(() => {
    if (shouldShowMobileNudgeExperiment) {
      analytics.track(
        GET_STARTED_CHECKLIST_SHOULD_SHOW_MOBILE_NUDGE_EXPERIMENT
      );
    }
  }, [shouldShowMobileNudgeExperiment]);

  return (
    <div>
      <Text>
        Download the desktop app to record from anywhere. Install the Chrome
        extension to record from your browser and to unlock integrations like
        Gmail and Jira.
      </Text>
      <Spacer top="large">
        <Button
          variant="primary"
          icon={<SvgChrome />}
          onClick={() => {
            analytics.track(GET_STARTED_CHECKLIST_EXTENSION_INSTALL_CLICKED);
            completeChecklistItem();
            window.open(CHROME_EXT_WEBSTORE_URL, '_blank');
          }}
          hasFullWidth
        >
          Install Chrome Extension
        </Button>
      </Spacer>

      {isSupportedDesktopPlatform && (
        <Spacer top="small">
          <DownloadDesktopButton
            hasFullWidth
            afterOnClick={() => {
              analytics.track(
                GET_STARTED_CHECKLIST_DESKTOP_APP_INSTALL_CLICKED,
                {
                  platform,
                }
              );

              completeChecklistItem();
            }}
          />
        </Spacer>
      )}

      {shouldShowMobileNudgeExperiment && (
        <FeatureFlaggedComponent
          flag={EXP_MOBILE_NUDGE_IN_ONBOARDING_CHECKLIST}
          activationValues={['variant']}
        >
          <Spacer top="small">
            <TextButton
              icon={<Icon color="primary" icon={<SvgMobileDevices />} />}
              onClick={() => {
                analytics.track(
                  GET_STARTED_CHECKLIST_MOBILE_APP_INSTALL_CLICKED
                );
                window.open(MOBILE_WEB, '_blank');
              }}
            >
              <Text color="primary">Get Loom on iOS & Android</Text>
            </TextButton>
          </Spacer>
        </FeatureFlaggedComponent>
      )}
    </div>
  );
};

export default DownloadCTA;
